import { combineReducers } from 'redux'
import { without, omit } from 'lodash'
import { NOTIFICATION_SHOW, NOTIFICATION_DISMISS, NOTIFICATION_CLEAR } from './actionTypes'

const notification = (state = {}, action) => {
	switch (action.type) {
		case NOTIFICATION_SHOW:
			return action.payload
		case NOTIFICATION_DISMISS:
			return undefined
		default:
			return state
	}
}

// At most this many on screen; the oldest goes first
const MAX_VISIBLE = 3

const allIds = (state = [], action) => {
	switch (action.type) {
		case NOTIFICATION_SHOW:
			// A repeated message moves to the newest spot rather than appearing twice
			return [...without(state, action.payload.id), action.payload.id].slice(-MAX_VISIBLE)
		case NOTIFICATION_DISMISS:
			return without(state, action.payload)
		case NOTIFICATION_CLEAR:
			return []
		default:
			return state
	}
}

const byId = (state = {}, action) => {
	switch (action.type) {
		case NOTIFICATION_SHOW:
			return {
				...state,
				[action.payload.id]: notification(state[action.payload.id], action)
			}
		case NOTIFICATION_CLEAR:
			return {}
		case NOTIFICATION_DISMISS:
			return omit(state, action.payload)
		default:
			return state
	}
}

export const notifications = combineReducers({ byId, allIds })

export default notifications
